var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136.75 153.84",
    style: {
      enableBackground: "new 0 0 136.75 153.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EA3A8;}\n\t.st1{display:none;opacity:0.5;fill:#010101;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05,
    y: 35.23,
    className: "st0",
    width: 15,
    height: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.14,
    y: 18.14,
    className: "st0",
    width: 15,
    height: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.23,
    y: 1.05,
    className: "st0",
    width: 15,
    height: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.05,
    y: 52.33,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 17.0935 119.6547)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.23,
    y: 86.51,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 85.4676 188.0288)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52.33,
    y: 1.05,
    className: "st0",
    width: 15,
    height: 15
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.33,
    y: 86.51,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 119.6547 188.0288)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 69.42,
    y: 69.42,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 153.8417 153.8417)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.51,
    y: 86.51,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 188.0288 188.0288)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103.61,
    y: 103.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 222.2158 222.2158)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 120.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 256.4029 256.4029)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 137.79,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 256.4029 290.5899)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.42,
    y: 86.51,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 153.8417 188.0288)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 86.51,
    y: 103.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 188.0288 222.2158)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 103.61,
    y: 120.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 222.2158 256.4029)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 86.51,
    y: 52.33,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 188.0288 119.6547)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 86.51,
    y: 35.23,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 188.0288 85.4676)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 69.42,
    y: 18.14,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 153.8417 51.2806)",
    className: "st0",
    width: 15,
    height: 15
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 18.14,
    y: 69.42,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 51.2806 153.8417)",
    className: "st0",
    width: 15,
    height: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,53.4C0,28.01,20.58,7.43,45.97,7.43S91.93,28.01,91.93,53.4c0,8.69-2.41,16.83-6.46,23.9l33.19,33.19 c4.31,4.31,4.31,11.29,0,15.6c-4.31,4.31-11.29,4.31-15.6,0L69.72,92.75c-6.93,4.19-15.06,6.61-23.76,6.61 C20.58,99.36,0,78.78,0,53.4z M14.71,53.4c0,17.26,13.99,31.26,31.26,31.26S77.22,70.66,77.22,53.4S63.23,22.14,45.97,22.14 S14.71,36.13,14.71,53.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d3f0a91d159ba2a973e3e0a7699d1bd1.svg";
export { ForwardRef as ReactComponent };